// extracted by mini-css-extract-plugin
export default {"title":"CTABanner_title__LX7Ox","pitstopGif":"CTABanner_pitstopGif__2z2Cw"};